const LoginModel = {
  email: '',
  password: '',
};



export default LoginModel;
